export const app_version = '300'
export const app_version_hash = '766e720c2c372683f213556f37ddd6337360be81'
